import { Button, Dialog, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { ProjectConfig } from "Global";
import { ApiRequest } from "GlobalFunctions";

export default function UndeliveredConceptEditor(props: any) {
  const { setLoading, openEditor, setOpenEditor, undelivered_concept_id, loadList } = props;
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues = {
    undelivered_concept_id: undelivered_concept_id ? undelivered_concept_id : "null",
    concept: "",
  };

  const [formValues, setFormValues] = useState(defaultValues);

  useEffect(() => {
    if (undelivered_concept_id) {
      axios
        .get(`${ProjectConfig.api_url}/undelivered/details_concept`, {
          params: { undelivered_concept_id },
        })
        .then((response) => {
          setFormValues(response.data.data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    } else {
      setFormValues(defaultValues);
    }
  }, [undelivered_concept_id]);

  const handleInputChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = () => {
    setLoading(true);
    const body = new FormData();
    body.append("formValues", JSON.stringify(formValues));
    console.log("formValues", formValues);

  

    ApiRequest({
      url: "/undelivered/addedit_concept",
      method: "POST",
      headers: {
        ltkn: localStorage.getItem("ltkn") || "",
      },
      body: body,
      setResponse: (data: any) => {
        if (data.status === "success") {
          enqueueSnackbar("Concepto no entregado guardado con éxito", { variant: "success" });
          setOpenEditor(false);
          loadList();
        } else {
          enqueueSnackbar(data.message, { variant: "error" });
        }
      },
      setLoading,
    });
  };

  return (
    <Dialog open={openEditor} onClose={() => setOpenEditor(false)}>
      <div className="DialogContainer" style={{ maxWidth: "502px" }}>
        <div className="ModuleWrapper">
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <h2 className="h2_title">Concepto no entregado</h2>
              <span className="h2_subtitle">Editar</span>
            </div>
          </div>

          <div className="input_group">
            <TextField
              id="concept"
              name="concept"
              label="Concepto"
              type="text"
              required
              fullWidth
              value={formValues.concept}
              onChange={handleInputChange}
            />
          </div>

          <div className="dialogButtons">
            <Button onClick={() => setOpenEditor(false)} variant="outlined">
              Cancelar
            </Button>
            <Button onClick={handleSubmit} variant="contained">
              Guardar
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
